
module.exports = {
    // 渠道代码
    ZKICATMChannelCode: 'ZKICATM',//全民营销
    DPOWXPAChannelCode: 'DP_OWXPA',// C端商城
    DPWXMPChannelCode: 'DP_WXMP',//紫属保
    allChannelCode: 'ZKICATM, DP_OWXPA, DP_WXMP'
}


// WEBPACK FOOTER //
// ./src/api/configure.js